import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Categories.scss';
import stylesCatalog from './Catalog.scss';
import * as actions from 'src/redux/categoriesActions';
import Media from 'react-responsive';
import clock from 'src/imgs/clock-icon.svg';
import InlineSVG from 'react-svg-inline';
import carImg from 'src/imgs/car/car.png';
import CarBrandList from '../MainPage/elements/MainPageCarBrandList';
import SeenBlock from '../SeenBlock/SeenBlock';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';

export class Categories extends Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    // var sortedBrands = _.sortBy(this.props.brandList, ['brand']);
    // const brands = _.map(sortedBrands, (brand, i) => {
    //   return (
    //     <li><a href="#" className="link">{brand.brand}</a></li>
    //   );
    // });

    return (
      <div>
          <div className={stylesCatalog.Catalog}>
            <Breadcrumbs routes={this.props.routes}/>
            <CarBrandList rotes={this.props.routes}/>
            <Media query="(min-width: 1025px)">
              <SeenBlock />
            </Media>
          </div>
      </div>
    );
  }
}

Categories.routeTitle = "Марки";


export default connect(
  (state) => ({...state.categoriesReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(Categories);



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/Categories.jsx
 **/